/**
 * Constants regarding the sessionStorage
 */
export default Object.freeze({
  PREFIX: 'price_indicator',
  FIELDS_HAUS: [
    'hausNebengebaeudeM2',
    'kundeNachname',
    'hausNutzflaecheM2',
    'strasse',
    'indexHausBauweise',
    'hausKellerM2',
    'indexHausErhaltung',
    'hausNumberOfStoreys',
    'hausnr',
    'indexHausTyp',
    'hausBalkonM2',
    'indexArtGebaeudesanierung',
    'kundeAnrede',
    'kundeVorname',
    'grundFlaeche',
    'plz',
    'kundeEmail',
    'hausBaujahr',
    'ort',
    'hausWintergartenM2',
    'hausTerrasseM2',
    'f_zweck',
  ],
  FIELDS_WOHNUNG: [
    'plz',
    'ort',
    'strasse',
    'hausnr',
    'topnr',
    'staircase',
    'whgStockIst',
    'whgStockGesamt',
    'gebaeudeBaujahr',
    'whgNutzflaecheM2',
    'indexArtGebaeudesanierung',
    'indexArtFassade',
    'indexWhgErhaltung',
    'indexWhgAusstattung',
    'flagLift',
    'whgBalkonM2',
    'whgGaragenStk',
    'whgGartenM2',
    'whgKellerM2',
    'kundeAnrede',
    'kundeVorname',
    'kundeNachname',
    'kundeEmail',
    'flagKeller',
    'whgWintergartenM2',
    'whgTerrasseM2',
    'f_zweck',
  ],
  FIELDS_DG_WOHNUNG: [
    'plz',
    'ort',
    'strasse',
    'hausnr',
    'topnr',
    'staircase',
    'whgStockGesamt',
    'gebaeudeBaujahr',
    'whgNutzflaecheM2',
    'indexArtGebaeudesanierung',
    'indexArtFassade',
    'indexWhgErhaltung',
    'indexWhgAusstattung',
    'flagLift',
    'whgBalkonM2',
    'whgGaragenStk',
    'whgGartenM2',
    'whgKellerM2',
    'kundeAnrede',
    'kundeVorname',
    'kundeNachname',
    'kundeEmail',
    'flagKeller',
    'dachgeschossausbauBaujahr',
    'whgWintergartenM2',
    'whgTerrasseM2',
    'f_zweck',
  ],
  ID_THEMA_KAUFEN: 'E9D2F293800E3185E053301DC60A5D89',
  ID_THEMA_VERKAUFEN: 'E9D2F29380123185E053301DC60A5D89',
  ID_NL_SBAU: 'B8D83F32EFC03CD4E054020820F0E7BD',
  API_BASE_URL: 'https://immobilienbewertung.sparkasse.at/calculate/api',
  // for internal use only
  // API_BASE_URL: "http://allnet-services.stable.ibw.microf.cs.eb.lan.at/api/internal"
  NEWSLETTER_URL: 'https://nbca.erstegroup.com/prosoweb/customerregistrations',
  NEW_BUILDING_THRESHOLD: 35,
});
